/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const INCOMPLETE_TASK_METADATA_FRAGMENT = gql`
  fragment IncompleteTaskMetadata on IncompleteTaskMetadata {
    insightId
    message
    missingActionIds
    dueDate
  }
`
export const INCOMPLETE_RESTOCK_METADATA_FRAGMENT = gql`
  fragment IncompleteRestockMetadata on IncompleteRestockMetadata {
    insightId
    message
    missingActionIds
    dueDate
  }
`
export const REVENUE_OUTLIER_METADATA_FRAGMENT = gql`
  fragment RevenueOutlierMetadata on RevenueOutlierMetadata {
    insightId
    message
    relativeChangeDates
    relativeChangeValues
    relativeChangeIsOutlier
    populationWindow
    categories
  }
`
export const RECOMMENDED_SWAP_METADATA_FRAGMENT = gql`
  fragment RecommendedSwapMetadata on RecommendedSwapMetadata {
    insightId
    message
    displayId
    oldUpc
    oldCurrentFacings
    newUpc
    newCurrentFacings
  }
`
export const PRICE_MISMATCH_METADATA_FRAGMENT = gql`
  fragment PriceMismatchMetadata on PriceMismatchMetadata {
    insightId
    message
    displayId
    date
    upc
    expectedUnitPrice
    detectedUnitPrice
    detectedPriceType
    detectedPriceText
  }
`
export const PRODUCT_NOT_SOLD_METADATA_FRAGMENT = gql`
  fragment ProductNotSoldMetadata on ProductNotSoldMetadata {
    insightId
    message
    upc
    historicalRevenue
    lastSeenDate
  }
`

export const GET_TENANT_AI_INSIGHTS = gql`
  query GetTenantAiInsights(
    $filter: InsightsFilter
    $order: AiInsightOrder
    $pagination: OffsetLimitPaginationFilter
  ) {
    tenantAiInsights(filter: $filter, order: $order, pagination: $pagination) {
      results {
        priority
        store {
          id
          location {
            name
          }
        }
        sentiment
        insightType
        summary
        startDate
        endDate
        metadata {
          ...IncompleteTaskMetadata
          ...IncompleteRestockMetadata
          ...RevenueOutlierMetadata
          ...RecommendedSwapMetadata
          ...PriceMismatchMetadata
          ...ProductNotSoldMetadata
        }
      }
      totalCount
    }
  }
  ${INCOMPLETE_TASK_METADATA_FRAGMENT}
  ${INCOMPLETE_RESTOCK_METADATA_FRAGMENT}
  ${REVENUE_OUTLIER_METADATA_FRAGMENT}
  ${RECOMMENDED_SWAP_METADATA_FRAGMENT}
  ${PRICE_MISMATCH_METADATA_FRAGMENT}
  ${PRODUCT_NOT_SOLD_METADATA_FRAGMENT}
`
